import React from 'react';
import { Button, Input, message, Row, Col, Modal, Table, Tag, Form, Tooltip } from 'antd';
import { connect } from 'dva';
import moment from 'moment';
// eslint-disable-next-line import/extensions
import { getAppCode } from '../../../../utils/utils';
import styles from './select.less';

@connect(({ homePage }) => ({
  ...homePage,
}))
class SelectModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // submit 的loading
      loading: false,
      inputVal: '',
      selectedRowKeys: [],
      data: [],
      // 选中文章的名称标签
      tags: [],
      // table 的loading
      loadData: true,
      // 分页相关
      total: 0,
      page: 1,
      pageSize: 10,
      appCode: getAppCode(),
    };
  }

  componentDidMount() {
    this.getList();
    this.setData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.setData(nextProps);
  }

  setData = props => {
    const { selectNews = [], visible } = props;
    if (visible && !!selectNews.length) {
      const keys = [];
      const arr = [];
      selectNews.forEach(item => {
        keys.push(item.id);
        arr.push(item);
      });
      this.setState({
        tags: arr,
        selectedRowKeys: keys,
      });
    }
  };

  getList = () => {
    const { inputVal, page, pageSize, appCode } = this.state;
    const { dispatch, channelId = '' } = this.props;
    this.setState({ loadData: true });
    dispatch({
      type: 'homePage/fetchPublishList',
      params: {
        appCode,
        page,
        pageSize,
        title: inputVal,
        newsLabelId: 0,
        channelId,
        newsTypes: '0,1,2',
      },
    })
      .then(res => {
        const { content, totalElements } = res || {};
        const arr = [];
        // 因为有行选择，需要有key值
        content.forEach(item => {
          arr.push({ ...item, key: item.id });
        });
        this.setState({
          data: arr,
          loadData: false,
          total: totalElements,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  onSearch = () => {
    this.setState({ page: 1 }, () => {
      this.getList();
    });
  };

  onComfirm = () => {
    const { tags, selectedRowKeys } = this.state;
    const { close, callBack } = this.props;
    this.setState({ loading: true });
    callBack(tags, selectedRowKeys);

    message.success('添加成功');
    setTimeout(() => {
      this.setState({
        loading: false,
        inputVal: '',
        selectedRowKeys: [],
        tags: [],
      });
      close();
    }, 200);
  };

  handleRows = (item, selected) => {
    const { selectedRowKeys, tags } = this.state;
    const { number } = this.props;

    if (selected && selectedRowKeys.length + 1 > number) {
      message.warning(`最多选择${number}篇文章`);
      return;
    }

    if (selected) {
      tags.push(item);
      selectedRowKeys.push(item.id);
    } else {
      tags.forEach((tag, index) => {
        if (tag.id === item.id) {
          tags.splice(index, 1);
          selectedRowKeys.splice(index, 1);
        }
      });
    }

    this.setState({
      tags,
      selectedRowKeys,
    });
  };

  inputChange = e => {
    this.setState({
      inputVal: e.target.value,
    });
  };

  // 移除选中的文章
  removeTags = key => {
    const { tags, selectedRowKeys } = this.state;
    const tagsTemp = [...tags].filter(tag => tag.id !== key && tag);
    const selectedRowKeysTemp = [...selectedRowKeys].filter(item => item !== key && item);

    this.setState({
      tags: tagsTemp,
      selectedRowKeys: selectedRowKeysTemp,
    });
  };

  closeModal = () => {
    const { close } = this.props;
    this.setState({ inputVal: '', selectedRowKeys: [], tags: [] });
    close();
  };

  render() {
    const {
      tags,
      data,
      inputVal,
      loading,
      loadData,
      selectedRowKeys,
      total,
      page,
      pageSize,
    } = this.state;

    const { visible, number } = this.props;

    const that = this;

    const tableHeader = [
      {
        title: '文章标题',
        dataIndex: 'title',
        render: text => {
          if (text.length <= 12) {
            return <span>{text}</span>;
          }
          return (
            <Tooltip placement="top" title={text}>
              <span>{text.substring(0, 12)}...</span>
            </Tooltip>
          );
        },
      },
      {
        title: '所属栏目',
        width: 200,
        dataIndex: 'id',
        render: (val, record) => (record.channel ? record.channel.title : ''),
      },
      {
        title: '最后编辑时间',
        width: 150,
        dataIndex: 'gmtModify',
        render: val => moment(val).format('YYYY.MM.DD HH:mm'),
      },
    ];

    const rowSelection = {
      selectedRowKeys,
      onSelect: this.handleRows,
    };

    const pagination = {
      total,
      pageSize,
      current: page,
      onChange(current) {
        that.setState({ page: current });
        setTimeout(() => {
          that.getList();
        }, 0);
      },
    };

    const formItemLayout = {
      labelCol: { span: 7 },
      wrapperCol: { span: 16 },
    };

    return (
      <div>
        <Modal
          title="选择文章"
          visible={visible}
          centered
          width={700}
          className={styles.modal}
          onCancel={this.closeModal}
          footer={[
            <span key="notice" className="footerText">
              <i>*</i>最多选择{number}篇文章
            </span>,
            <Button key="add" type="primary" loading={loading} onClick={this.onComfirm}>
              添加
            </Button>,
          ]}
        >
          <Row className={styles['ant-search-container']}>
            <Col span={15}>
              <Form.Item {...formItemLayout} label="搜索" style={{ marginBottom: 0 }}>
                <Input
                  className={styles['ant-search-input-info']}
                  placeholder="请搜索"
                  value={inputVal}
                  onPressEnter={this.onSearch}
                  onChange={this.inputChange}
                />
              </Form.Item>
            </Col>
          </Row>
          <div className={styles['ant-selected-tag']} style={{ paddingTop: 10 }}>
            {tags.map(tag => (
              <Tag
                key={tag.id}
                closable
                afterClose={() => this.removeTags(tag.id)}
                className={styles.tag}
              >
                {tag.title}
              </Tag>
            ))}
          </div>
          <Table
            pagination={pagination}
            rowSelection={rowSelection}
            columns={tableHeader}
            dataSource={data}
            size="middle"
            scroll={{ y: 300 }}
            loading={loadData}
            bordered
            className={styles.table}
          />
        </Modal>
      </div>
    );
  }
}
export default SelectModal;
